$(function() {
    $('.home-masthead-content').each(function(){
        $('h1', this).each(function(){
            var string = $.trim($(this).html());
            string = string.replace(/ ([^ ]*)$/,'&nbsp;$1');
            $(this).html(string);
        });
    });

    var AOS = require('aos');
    AOS.init();
})